import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Table from '../Table';

import { Block } from './Details.styles';

export function Details({ fields }) {
  return (
    <Block>
      {Object.keys(fields).map((item) => {
        const currentData = fields[item];

        return <Table key={item} id={item} items={currentData} />;
      })}
    </Block>
  );
}

Details.propTypes = {
  fields: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default memo(Details);
